// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__2TYmi","icon":"tooltip_icon__2AEzn","content":"tooltip_content__2-W9d","show":"tooltip_show__1n7kC"};